import React, { useState } from 'react';
import TranslationsSection from '@components/admin/translations/TranslationsSection';
import { Tabs, Tab } from 'react-bootstrap';
const TranslationsTabs = () => {
  const [key, setKey] = useState('en');
  return /*#__PURE__*/React.createElement(Tabs, {
    activeKey: key,
    onSelect: k => setKey(k),
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Tab, {
    eventKey: "en",
    title: "English"
  }, /*#__PURE__*/React.createElement(TranslationsSection, {
    locale: 'en'
  })));
};
export default TranslationsTabs;